import React from 'react';
import { Users, Shield, Package2, Clock } from 'lucide-react';
import { benefits } from '../data/mock';
import { useScrollAnimation } from '../hooks/useScrollAnimation';

const iconMap = {
  Users: Users,
  Shield: Shield,
  Package2: Package2,
  Clock: Clock,
};

const Benefits = () => {
  const [titleRef, titleVisible] = useScrollAnimation(0.1);
  const [cardsRef, cardsVisible] = useScrollAnimation(0.1);

  return (
    <section className="py-20 bg-[#E5E7EB] relative overflow-hidden">
      {/* Animated background elements */}
      <div className="absolute top-0 left-0 w-96 h-96 bg-[#EAB308]/5 rounded-full blur-3xl animate-pulse" style={{ animationDuration: '4s' }}></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-[#CA8A04]/5 rounded-full blur-3xl animate-pulse" style={{ animationDuration: '5s' }}></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div
          ref={titleRef}
          className={`text-center mb-16 ${titleVisible ? 'animate-fade-in-up' : 'animate-on-scroll'}`}
        >
          <h2 className="text-3xl sm:text-4xl font-bold text-[#111827] mb-4">
            Porquê Escolher-nos?
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Profissionalismo, segurança e confiança em cada mudança
          </p>
        </div>

        <div ref={cardsRef} className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {benefits.map((benefit, index) => {
            const Icon = iconMap[benefit.icon];
            return (
              <div
                key={benefit.id}
                className={`bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-500 hover:-translate-y-3 group hover-lift hover-glow h-full flex flex-col ${cardsVisible ? 'animate-fade-in-up' : 'animate-on-scroll'
                  } delay-${index + 1}00`}
              >
                <div className="w-16 h-16 bg-gradient-to-br from-[#EAB308] to-[#CA8A04] rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 group-hover:rotate-6 transition-all duration-300 shadow-lg">
                  <Icon className="w-8 h-8 text-white" />
                </div>
                <h3 className="text-xl font-bold text-[#111827] mb-3 group-hover:text-[#EAB308] transition-colors duration-300">
                  {benefit.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {benefit.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Benefits;
